export { cn } from './classnameUtils';

export { sideBarMenuList, sideBarAdminMenuList, getPathToTitleObj } from './sidebarUtils';

export { manageTabs } from './manageUtils';

/**
 * altitudeMeters를 km로 변환
 * @param altitudeMeters 미터 단위 고도
 * @returns km 단위 고도
 */
export const convertAltitudeToKm = (altitudeMeters: number): number => {
  return altitudeMeters / 1000;
};

/**
 * altitudeMeters를 km로 변환하여 문자열로 반환
 * @param altitudeMeters 미터 단위 고도
 * @returns km 단위 고도 문자열
 */
export const convertAltitudeToKmString = (altitudeMeters: number): string => {
  return (altitudeMeters / 1000).toString();
};
